module.exports.REPEATABLE_SECTION_STATE = {
    View: 'View',
    Update: 'Update',
    Create: 'Create',
};
